import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import StateResponsibleSelector from './StateResponsibleSelector'
import CurrentStateAndTask from './CurrentStateAndTask'
import StateLastChanged from './StateLastChanged'
import TaskByDueDate from './TaskByDueDate'

const StateResponsible = (props) => {
    return (
        <div>
            <StateResponsibleSelector {...props}/>
            <CurrentStateAndTask {...props}/>
            <StateLastChanged {...props}/>
            <TaskByDueDate {...props}/>
        </div>)
}


StateResponsible.propTypes = {
    stateAnalytics: PropTypes.object,
    stateByLastChangedList: PropTypes.array,
    taskByDueDateList: PropTypes.array,
    taskList: PropTypes.array,
    userSelection: PropTypes.object.isRequired,
    getStateAnalytics: PropTypes.func.isRequired,
    getStateLastChanged: PropTypes.func.isRequired,
    getTaskByDueDate: PropTypes.func.isRequired,
    findTaskByWeekDiff: PropTypes.func.isRequired,
    changeUserSelection: PropTypes.func.isRequired,
    processNameList: PropTypes.array.isRequired,
}

export default withLayout(StateResponsible)





// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/StateResponsible.js